import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './Team.css';
import PageTitle from '../Layout/components/PageTitle';
import { Button, Paper, Table, TableHead, TableRow, TableCell, TableBody, Dialog, Breadcrumbs, Link, Typography, InputBase } from '@material-ui/core';
import TeamInfo from './components/TeamInfo';
import Search from '@material-ui/icons/Search'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { ADD, EDIT, VIEW } from '../../common/common'
import { timeFormat } from '../../common/utils'
import instance from '../../request/http';
import { BASE_URL } from '../../store/config';
import Toast from '../Layout/components/Toast';
import AlertDialog from '../Layout/components/AlertDialog'

const TEAM = "team_leader";
const STAFF = "staff";
class Team extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            dialogState: ADD,
            dialogTitle: "",
            currentObj: null,
            deptName: "",
            teamData: [],
            teamDataCopy: [],

            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false
        }
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleAddTeam = this.handleAddTeam.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.createTeams = this.createTeams.bind(this);
        this.addTeamMembers = this.addTeamMembers.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }
    render() {
        const {
            deptName,
            teamData,
            showToast,
            toastMsg,
            toastState,
            showAlert,
        } = this.state;
        return (
            <Root>
                <div className="head h">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <Link className="title" href="/main/department">All Department</Link>
                            <Typography className="crtTitle">{deptName} TEAM</Typography>
                        </Breadcrumbs>
                    </div>
                    <div className="f h h-r">
                        <Button variant="contained" color="primary" onClick={this.handleAddTeam}>ADD TEAM</Button>
                    </div>
                    <Dialog maxWidth={false} open={this.state.open}>
                        <TeamInfo
                            handleCreate={this.handleCreate}
                            handleCancel={this.handleCancel}
                            title={this.state.dialogTitle}
                            data={this.state.currentObj}
                            state={this.state.dialogState}
                        ></TeamInfo>
                    </Dialog>
                </div>
                <div className="search h">
                    <div className="search-icon c">
                        <Search />
                    </div>
                    <InputBase
                        placeholder="Search Team Name"
                        inputProps={{ 'aria-label': 'Search' }}
                        onChange={this.handleSearch}
                    />
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell className="cell">Team Name</TableCell>
                                <TableCell className="cell">Team Member</TableCell>
                                <TableCell className="cell">Update Time</TableCell>
                                <TableCell className="cell">Create Time</TableCell>
                                <TableCell className="cell">Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {teamData.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{this.membersNum(row.members)}</TableCell>
                                    <TableCell>{timeFormat(row.update_time)}</TableCell>
                                    <TableCell>{timeFormat(row.create_time)}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this team?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        let dept_id = localStorage.getItem('dept_id');
        const deptName = localStorage.getItem("dept_name");
        this.setState(() => ({
            deptName
        }))
        const params = {
            dept_id
        }
        this.getTeams(params);
    }
    handleSearch(e) {
        const value = e.target.value;
        const { teamDataCopy } = this.state;
        const arr = this.filterIncludeArr(teamDataCopy, value);
        this.setState(() => ({
            teamData: arr
        }))
    }
    handleAddTeam() {
        this.openDialog("ADD " + this.state.deptName + " TEAM", ADD);
    }
    handleView(e, obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openDialog(obj.name + " TEAM INFO", VIEW);
    }
    handleEdit(e, obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openDialog("EDIT " + obj.name + " TEAM INFO", EDIT);
    }
    handleDel(e, obj) {
        this.setState(() => ({
            currentObj: obj,
            showAlert: true
        }))
    }
    //关闭dialog
    handleCloseDialog() {
        this.closeDialog();
    }
    handleCreate(obj, members) {
        const { dialogState, currentObj } = this.state;
        let dept_id = parseInt(localStorage.getItem("dept_id"));
        if (dialogState === ADD) {
            //添加team时是没有teamId的 所以要先创建team后得到teamId再进行成员添加
            this.createTeams(dept_id, obj, members);
        } else if (dialogState === EDIT) {
            let team_id = currentObj.id;
            let params = {};
            if (currentObj.name === obj.name) {
                params = {
                    dept_id,
                    description: obj.description,
                }
            } else {
                params = {
                    dept_id,
                    name: obj.name,
                    description: obj.description,
                }
            }
            this.updateTeams(team_id, params);
        }
    }
    //取消dialog
    handleCancel() {
        this.closeDialog();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleAlertYes() {
        this.delTeam(this.state.currentObj.id);
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            currentObj: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    membersNum(arr) {
        if (arr) {
            let members = 0;
            for (const obj of arr) {
                if (obj.role.name === STAFF || obj.role.name === TEAM) {
                    members++;
                }
            }
            return members;
        } else {
            return 0;
        }
    }
    filterIncludeArr(arr, value) {
        let newArr = [];
        for (let obj of arr) {
            if (obj.name.includes(value)) {
                newArr.push(obj);
            };
        }
        return newArr;
    }
    //-----------request-------------
    getTeams(params) {
        instance.get(BASE_URL + 'admin/teams', { params }).then((res) => {
            const teamData = res.data.data;
            console.log("teamData", teamData)
            this.setState(() => ({
                teamData,
                teamDataCopy: teamData
            }));
        })
    }
    // POST  admin/teams/<int: team_id>/members
    // DELETE  admin/teams/<int: team_id>/members
    createTeams(dept_id, teamObj, members) {
        console.log("members", members)
        let params = {
            name: teamObj.name,
            dept_id,
            description: teamObj.description,
        }
        instance.post(BASE_URL + 'admin/teams', params).then((res) => {
            let teamId = res.data.data.id;
            const params = {
                dept_id
            }
            if (members.length !== 0) {
                this.addTeamMembers(teamId, members, () => {
                    this.getTeams(params);
                });
            } else {
                this.getTeams(params);
            }
            this.showToast("Added successfully", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    updateTeams(team_id, params) {
        instance.put(BASE_URL + "admin/teams/" + team_id, params).then((res) => {
            console.log("editTeam", res);
            const dept_id = parseInt(localStorage.getItem("dept_id"));
            const params = {
                dept_id
            }
            this.getTeams(params);
            this.showToast("Successfully modified", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delTeam(team_id) {
        instance.delete(BASE_URL + "admin/teams/" + team_id).then((res) => {
            console.log("deletteam", res);
            const dept_id = parseInt(localStorage.getItem("dept_id"));
            const params = {
                dept_id
            }
            this.getTeams(params);
            this.showToast("Successfully deleted", "success");
        }).catch((err) => {
            // const msg = err.response.data.message;
            this.showToast("Team is not empty", "error");
        })
    }
    //members(array)   结构[ {user_id:**,  role_id:**}, {user_id:**,  role_id:**}]
    addTeamMembers(team_id, members, callback) {
        let params = {
            members
        }
        instance.post(BASE_URL + "admin/teams/" + team_id + "/members", params).then((res) => {
            console.log("addteam", res);
            this.showToast("Added successfully", "success");
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    //members(array)   结构[ {user_id:**,  role_id:**}, {user_id:**,  role_id:**}]
    delTeamMembers(team_id, members) {
        let params = {
            members
        }
        instance.delete(BASE_URL + "admin/teams/" + team_id + "/members", { data: params }).then((res) => {
            console.log("delMembers", res);
            this.showToast("Successfully deleted", "success");
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default withRouter(Team);